import { ColumnDatasource } from '@/shared/resources/datasources/column-datasource'

export abstract class CommonLaboratoryDatasource<T> extends ColumnDatasource<T> {
    readonly laboratoryId: number

    constructor(laboratoryId: number) {
        super()
        this.laboratoryId = laboratoryId
    }
}
